module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"policy":"die Datenschutzerklärung","read":"Ich habe gelesen die"},"en":{"policy":"the privacy policy","read":"I have read"},"it":{"policy":"Privacy","read":"Ho letto l’informativa sulla"},"lt":{"policy":"Privatumo politika","read":"Sutinku su"},"pl":{"policy":"polityka prywatności","read":"Przeczytałem/-am"},"es":{"policy":"la política de privacidad","read":"He leído"}}')
  delete Component.options._Ctor
}
